import {
  Button,
  // CardContent,
  Checkbox,
  DialogActions,
  MenuItem,
  TextField
} from "@material-ui/core";
import Dialog from "@material-ui/core/Dialog";
import DialogContent from "@material-ui/core/DialogContent";
import DialogTitle from "@material-ui/core/DialogTitle";
import { makeStyles } from "@material-ui/core/styles";
import TableCell from "@material-ui/core/TableCell";
// import TableRow from "@material-ui/core/TableRow";
import VisibilityIcon from "@material-ui/icons/Visibility";
import VisibilityOffIcon from "@material-ui/icons/VisibilityOff";
// import ResponsiveTable from "@saleor/components/ResponsiveTable";
import TableCellAvatar from "@saleor/components/TableCellAvatarCopy";
import { buttonMessages } from "@saleor/intl";
import { maybe } from "@saleor/misc";
import { SearchInstagrams_search_edges_node } from "@saleor/searches/types/SearchInstagrams";
import useScrollableDialogStyle from "@saleor/styles/useScrollableDialogStyle";
import { ReorderAction } from "@saleor/types";
import React from "react";
import { FormattedMessage, useIntl } from "react-intl";
import { FixedSizeList } from "react-window";

import ConfirmButton from "../ConfirmButton";
import Skeleton from "../Skeleton";
import { SortableTableBody, SortableTableRow } from "../SortableTable";

export interface FormData {
  Instagrams: SearchInstagrams_search_edges_node[];
  query: string;
}

const useStyles = makeStyles(
  {
    avatar: {
      "&&:first-child": {
        paddingLeft: 0
      },
      width: 72
    },
    checkboxCell: {
      paddingLeft: 0,
      width: 88
    },
    columnReOrder: {
      width: 180,
      textAlign: "center",
      padding: 0,
      paddingRight: 60
    },
    colName: {
      paddingLeft: 0
    },
    link: {
      cursor: "pointer"
    }
  },
  { name: "AssigninstagramDialog" }
);

export interface AssigninstagramDialogProps {
  open: boolean;
  onInsReorder?: ReorderAction;
  instargrams: SearchInstagrams_search_edges_node[];
  onClose: () => void;
  onSubmit: (data: SearchInstagrams_search_edges_node[]) => void;
  onRowClick: (id: string) => () => void;
  reverseVisible: (data: SearchInstagrams_search_edges_node[]) => void;
  onInsSelectReorder?: (insId: string, sortOrder: number) => void;
}

function handleInstagramAssign(
  instargram: SearchInstagrams_search_edges_node,
  isSelected: boolean,
  selectedInstargrams: SearchInstagrams_search_edges_node[],
  setSelectedInstargrams: (data: SearchInstagrams_search_edges_node[]) => void
) {
  if (isSelected) {
    setSelectedInstargrams(
      selectedInstargrams.filter(
        selectedInstargram => selectedInstargram.id !== instargram.id
      )
    );
  } else {
    setSelectedInstargrams([...selectedInstargrams, instargram]);
  }
}
function handleInstagramsAssign(
  instargrams: SearchInstagrams_search_edges_node[],
  selectedInstargrams: SearchInstagrams_search_edges_node[],
  setSelectedInstargrams: (data: SearchInstagrams_search_edges_node[]) => void
) {
  if (selectedInstargrams.length === instargrams.length) {
    setSelectedInstargrams([]);
  } else {
    setSelectedInstargrams(instargrams);
  }
}

const AssignInstagramDialog: React.FC<AssigninstagramDialogProps> = props => {
  const {
    open,
    instargrams,
    onInsReorder,
    onClose,
    onSubmit,
    onRowClick,
    reverseVisible,
    onInsSelectReorder
  } = props;
  const classes = useStyles(props);
  const scrollableDialogClasses = useScrollableDialogStyle({});
  const [selectedInstargrams, setSelectedInstargrams] = React.useState<
    SearchInstagrams_search_edges_node[]
  >([]);
  const handleSubmit = () => onSubmit(selectedInstargrams);
  const updateVisible = () => reverseVisible(selectedInstargrams);

  const intl = useIntl();
  const onChangeReorder = event => {
    // eslint-disable-next-line no-console
    const newIndex = event.target.value;
    const ins = event.target.name.split("_");
    if (newIndex && ins) {
      const insId = ins[0];
      const oldIndex = ins[1];
      // eslint-disable-next-line no-console

      onInsSelectReorder(insId, newIndex - oldIndex);
    }
  };
  const itemData = () =>
    instargrams.map((item, index) => (
      <MenuItem key={item.id} value={index + 1}>
        {index + 1}
      </MenuItem>
    ));

  return (
    <Dialog
      onClose={onClose}
      open={open}
      classes={{ paper: scrollableDialogClasses.dialog }}
      fullWidth
      maxWidth="md"
    >
      <DialogTitle>
        <FormattedMessage
          defaultMessage="Assign Content"
          description="dialog header"
        />
      </DialogTitle>
      <DialogContent style={{ padding: "24px 0 0 24px" }}>
        {/* <CardContent > */}
        {/* <ResponsiveTable key="table"> */}
        <SortableTableBody onSortEnd={onInsReorder ? onInsReorder : null}>
          <FixedSizeList
            width={935}
            height={518}
            itemSize={60}
            itemCount={instargrams?.length}
            className="FixedSizeList"
          >
            {({ style, index }) => {
              const isSelected = selectedInstargrams.some(
                selectedInstargram =>
                  selectedInstargram.id === instargrams[index].id
              );
              return (
                <>
                  {instargrams.length > 0 && (
                    <SortableTableRow
                      style={style}
                      className={
                        !!instargrams[index] ? classes.link : undefined
                      }
                      hover={!!instargrams[index]}
                      key={instargrams[index].id}
                      index={index || 0}
                      onClick={() => {
                        onRowClick(instargrams[index].instagram.id);
                      }}
                    >
                      <TableCell className={classes.columnReOrder}>
                        {maybe(() => instargrams[index]) ? (
                          <TextField
                            label={intl.formatMessage({
                              defaultMessage: "Reorder",
                              description: "Reorder"
                            })}
                            select
                            type="number"
                            onClick={event => event.stopPropagation()}
                            // name={"usageLimit" as keyof FormData}
                            name={instargrams[index].id + "_" + (index + 1)}
                            key={instargrams[index].id + "_" + (index + 1)} // 必须加key 不然defaultvalue一直不变
                            data-ins={instargrams[index]}
                            style={{ textAlign: "left", overflow: "hidden" }}
                            defaultValue={
                              maybe(() => instargrams[index]) ? index + 1 : ""
                            }
                            onChange={onChangeReorder}
                          >
                            {itemData()}
                          </TextField>
                        ) : (
                          <Skeleton />
                        )}
                      </TableCell>
                      <TableCellAvatar
                        thumbnail={maybe(() =>
                          instargrams[index].instagram?.imageThumb
                            .replace("default.jpg", "thumb.jpg.webp")
                            .replace("cover.jpg", "cover.jpg.webp")
                        )}
                        data-test="name"
                        style={{ width: "153px" }}
                      />

                      <TableCell
                        title={instargrams[index].userName || ""}
                        onClick={
                          !!instargrams[index]
                            ? onRowClick(instargrams[index].instagram.id)
                            : undefined
                        }
                        style={{
                          textAlign: "center",
                          overflow: "hidden", // 超出的文本隐藏
                          textOverflow: "ellipsis", // 溢出用省略号显示
                          whiteSpace: "nowrap", // 溢出不换行
                          width: 200,
                          maxWidth: 200
                        }}
                      >
                        {maybe(() => instargrams[index].userName) ? (
                          instargrams[index].userName
                        ) : (
                          <Skeleton />
                        )}
                      </TableCell>
                      <TableCell
                        style={{ textAlign: "center", width: "200px" }}
                      >
                        {maybe(() => instargrams[index]) ? (
                          instargrams[index].visible ? (
                            <VisibilityIcon color={"primary"} />
                          ) : (
                            <VisibilityOffIcon color={"secondary"} />
                          )
                        ) : (
                          <Skeleton />
                        )}
                      </TableCell>
                      <TableCell
                        padding="checkbox"
                        className={classes.checkboxCell}
                      >
                        <Checkbox
                          checked={isSelected}
                          onChange={() =>
                            handleInstagramAssign(
                              instargrams[index],
                              isSelected,
                              selectedInstargrams,
                              setSelectedInstargrams
                            )
                          }
                        />
                      </TableCell>
                    </SortableTableRow>
                  )}
                </>
              );
            }}
          </FixedSizeList>
          {/* {instargrams &&
                renderCollection(
                  instargrams,
                  (instargram, instargramIndex) => {
                    const isSelected = selectedInstargrams.some(
                      selectedInstargram =>
                        selectedInstargram.id === instargram.id
                    );
                    return (
                      <SortableTableRow
                        className={!!instargram ? classes.link : undefined}
                        hover={!!instargram}
                        key={instargram.id}
                        index={instargramIndex || 0}
                        onClick={() => {
                          onRowClick(instargram.instagram.id);
                        }}
                      >
                        <TableCell className={classes.columnReOrder}>
                          {maybe(() => instargram) ? (
                            <TextField
                              label={intl.formatMessage({
                                defaultMessage: "Reorder",
                                description: "Reorder"
                              })}
                              select
                              type="number"
                              onClick={event => event.stopPropagation()}
                              // name={"usageLimit" as keyof FormData}
                              name={instargram.id + "_" + (instargramIndex + 1)}
                              key={instargram.id + "_" + (instargramIndex + 1)} // 必须加key 不然defaultvalue一直不变
                              data-ins={instargram}
                              style={{ textAlign: "left", overflow: "hidden" }}
                              defaultValue={
                                maybe(() => instargram)
                                  ? instargramIndex + 1
                                  : ""
                              }
                              onChange={onChangeReorder}
                            >
                              {itemData()}
                            </TextField>
                          ) : (
                            <Skeleton />
                          )}
                        </TableCell>
                        <TableCellAvatar
                          thumbnail={maybe(() =>
                            instargram.instagram?.imageThumb
                              .replace("default.jpg", "thumb.jpg.webp")
                              .replace("cover.jpg", "cover.jpg.webp")
                          )}
                          data-test="name"
                        />

                        <TableCell
                          onClick={
                            !!instargram
                              ? onRowClick(instargram.instagram.id)
                              : undefined
                          }
                          style={{
                            textAlign: "center",
                            overflow: "hidden", // 超出的文本隐藏
                            textOverflow: "ellipsis", // 溢出用省略号显示
                            whiteSpace: "nowrap", // 溢出不换行
                            width: 200
                          }}
                        >
                          {maybe(() => instargram.userName) ? (
                            instargram.userName
                          ) : (
                            <Skeleton />
                          )}
                        </TableCell>
                        <TableCell style={{ textAlign: "center" }}>
                          {maybe(() => instargram) ? (
                            instargram.visible ? (
                              <VisibilityIcon color={"primary"} />
                            ) : (
                              <VisibilityOffIcon color={"secondary"} />
                            )
                          ) : (
                            <Skeleton />
                          )}
                        </TableCell>
                        <TableCell
                          padding="checkbox"
                          className={classes.checkboxCell}
                        >
                          <Checkbox
                            checked={isSelected}
                            onChange={() =>
                              handleInstagramAssign(
                                instargram,
                                isSelected,
                                selectedInstargrams,
                                setSelectedInstargrams
                              )
                            }
                          />
                        </TableCell>
                      </SortableTableRow>
                    );
                  },
                  () => (
                    <TableRow>
                      <TableCell colSpan={6}>
                        <FormattedMessage
                          defaultMessage="No Ins found"
                          description="No Ins found"
                        />
                      </TableCell>
                    </TableRow>
                  )
                )} */}
        </SortableTableBody>
        {/* </ResponsiveTable> */}
        {/* </CardContent> */}
      </DialogContent>
      <DialogActions style={{ justifyContent: "space-between" }}>
        <Button
          onClick={() =>
            handleInstagramsAssign(
              instargrams,
              selectedInstargrams,
              setSelectedInstargrams
            )
          }
          style={{ float: "left" }}
        >
          <FormattedMessage defaultMessage="Select All" description="button" />
        </Button>
        <Button
          onClick={() => {
            updateVisible();
            setSelectedInstargrams([]);
          }}
          style={{ float: "left" }}
        >
          <FormattedMessage
            defaultMessage="Update Visible"
            description="button"
          />
        </Button>
        <div>
          <Button onClick={onClose} style={{ margin: 10 }}>
            <FormattedMessage {...buttonMessages.back} />
          </Button>
          <ConfirmButton
            transitionState={null}
            color="primary"
            variant="contained"
            type="submit"
            onClick={() => {
              setSelectedInstargrams([]);
              handleSubmit();
            }}
          >
            <FormattedMessage
              defaultMessage="Assign products"
              description="button"
            />
          </ConfirmButton>
        </div>
      </DialogActions>
    </Dialog>
  );
};
export default AssignInstagramDialog;
